<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Raporty TU'" [name]="'Importuj'"></app-breadcrumb>
<div class="commission-import" fxLayout="column" fxLayoutGap="15px" [formGroup]="commissionImportForm">
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
      <div fxLayout="row">
        <mat-card fxLayout="column" fxLayoutGap="15px" fxFlex="100">
          <div fxLayout="row">
            <h3>Dane importu</h3>
          </div>

          <app-file-drag-and-drop
            [multiple]="false"
            [generateOutput]="true"
            (fileSelected)="fileSelected($event)"
            [maxSize]="fileMaxSize"
            acceptMime="text/csv"
          ></app-file-drag-and-drop>

          <mat-error *ngIf="commissionImportForm.get('fileContent').hasError('backendError')">
            {{ commissionImportForm.get('fileContent').getError('backendError') }}
          </mat-error>

          <div fxLayout="row">
            <app-month-picker
              fxFlex="100"
              label="Miesiąc rozliczeniowy" [required]="true"
              [control]="billingMonthControl"
            ></app-month-picker>
          </div>

          <div fxLayout="row">
            <app-dict
              fxFlex="100"
              label="Firma"
              dictType="company"
              [control]="companyControl"
              [required]="true"
            ></app-dict>
          </div>

          <div fxLayout="row" *ngIf="!profitChecked">
            <app-dict-insurance-companies
              fxFlex="100" label="TU"
              [required]="insuranceRequired"
              [control]="insuranceCompanyControl"
              (selectedInsuranceCompany)="selectedInsuranceCompany = $event"
              [hideChildren]="true"
            ></app-dict-insurance-companies>
          </div>
          <div fxLayout="row" *ngIf="profitChecked">
            <app-dict-insurance-companies
              fxFlex="100" label="TU"
              [required]="profitChecked"
              [control]="insuranceCompanyControl"
              [profit]="profitChecked"
              [hideChildren]="true"
              (selectedInsuranceCompany)="selectedInsuranceCompany = $event"
            ></app-dict-insurance-companies>
          </div>

          <div fxLayout="row">
            <app-dict
              fxFlex="100" [required]="insuranceRequired"
              [control]="importerControl"
              [dictType]="'commission_importer_' + selectedInsuranceCompany?.key"
              matTooltip="Najpierw wybierz TU"
              matTooltipPosition="left"
              [matTooltipDisabled]="!!selectedInsuranceCompany"
              label="Importer"
              (availableItems)="onAvailableImportersChange($event)"
              [profit]="profitChecked"
            ></app-dict>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="50">
              <mat-slide-toggle color="accent" (change)="slideChange($event, 3)" [formControl]="profitControl">
                Profitowi
              </mat-slide-toggle>
            </div>
            <div fxFlex="50">
              <mat-slide-toggle color="accent" (change)="slideChange($event, 1)" [formControl]="overCommissionControl">
                Nadprowizja
              </mat-slide-toggle>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px">
            <div fxFlex="50">
              <mat-slide-toggle color="accent" (change)="slideChange($event, 2)" [formControl]="cancellationControl">
                Storno
              </mat-slide-toggle>
            </div>
            <div fxFlex="50">
              <mat-slide-toggle color="accent" (change)="slideChange($event, 4)"
                                [formControl]="additionalSettlementControl">
                Dodatkowe rozliczenie
              </mat-slide-toggle>
            </div>
          </div>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="templateOverCommission">
            <a href="/rest/crm/static/doc/szablon_importu_nadprowizji.xlsx" target="_blank" mat-stroked-button
               color="primary">
              <mat-icon>download</mat-icon>
              Szablon importu (Nadprowizja)
            </a>
          </div>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="templateCancellation">
            <a href="/rest/crm/static/doc/szablon_importu_storno.xlsx" target="_blank" mat-stroked-button
               color="primary">
              <mat-icon>download</mat-icon>
              Szablon importu (Storno)
            </a>
          </div>
          <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf="templateAdditionalSettlement">
            <a href="/rest/crm/static/doc/szablon_importu_dodatowe_rozliczenie.xlsx" target="_blank" mat-stroked-button
               color="primary">
              <mat-icon>download</mat-icon>
              Szablon importu (Dodatkowe rozliczenie)
            </a>
          </div>
        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="import()" [class.spinner]="processingRequest"
            [disabled]="!commissionImportFormValid"
            mat-stroked-button color="primary">
      <mat-icon>publish</mat-icon>
      <span> Importuj</span></button>
  </div>
</div>
